<template>
    <Dialog v-model="show" title="COLUNAS FIXADAS" :show-close-button="true" :options="{width: '60%'}" @close="closeDialog" :buttons="buttons">
        <p>
            Colunas já selecionadas
        </p>
        <div class="container-list-selecionados">
            <div class="container-card-selecionado" v-for="(item, index) in listCheckedItems" :key="index.value">
                {{ item }}
            </div>
        </div>
        <div style="margin-top: 12px;">
            <p>
                Selecione até 3 colunas para fixar na listagem
            </p>
        </div>
        <div class="container-columns" v-if="selectedItems != undefined">
            <div class="column" v-for="(item, index) in columns" :key="index">
                <v-checkbox
                        color="secondary"
                        :input-value="selectedItems[item.value]"
                        :true-value="true"
                        :false-value="false"
                        :disabled="!selectedItems[item.value] && (totalSelecionados >= 3)"
                        @change="onCheckItem(item.value)"
                >
                    <template v-slot:label>
                        <span class="checkbox-label">{{ item.text }}</span>
                    </template>
                </v-checkbox>
            </div>
        </div>
    </Dialog>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import { AlertTypes } from '../plugins/alerts_types'

  export default {
    name: 'DialogFixarColunas',
    props: {
      value: Boolean,
      table: String,
      columns: { text: String, value: String },
      alreadyFixedColumns: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        selectedItems: {},
        listCheckedItems: []
      }
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      },
      totalSelecionados () {
        return this.listCheckedItems.length
      },
      buttons () {
        return {
          OK: () => this.onConfirm()
        }
      }
    },
    watch: {
      show (val) {
        if (val) {
          this.selectedItems = {}
          this.listCheckedItems = []
          this.columns.forEach(item => {
            const isIncluded = this.alreadyFixedColumns.includes(item.value)
            this.selectedItems[item.value] = isIncluded
            if (isIncluded && !(this.listCheckedItems.includes(item.text))) this.listCheckedItems.push(item.text)
          })
          this.listCheckedItems = this.columns
            .filter(item => this.selectedItems[item.value])
            .map(item => item.text)
        }
      }
    },
    methods: {
      onCheckItem (item) {
        const selected = this.selectedItems

        // Alterna seleção
        selected[item] = !selected[item]

        // Verifica limite
        const selectedCount = Object.values(selected).filter(Boolean).length
        if (selectedCount > 3) {
          selected[item] = false // Desfaz seleção se exceder
          return
        }

        // Atualiza a lista com os textos dos itens selecionados
        this.listCheckedItems = Object.entries(selected)
          .filter(([key, isSelected]) => isSelected)
          .map(([key]) => {
            const col = Object.values(this.columns).find(c => c.value === key)
            return col?.text
          })
          .filter(Boolean) // Remove undefined se não encontrar coluna
      },
      onConfirm () {
        let fields = []
        this.listCheckedItems
          .map(value => {
            const item = this.columns.find(col => col.text === value)
            return item || null
          })
          .filter(val => val.text !== null && this.listCheckedItems.includes(val.text))
          .map(value => fields.push(value.value))

        this.$http.post('/painel/fixed/fields/lists', {
          table: this.table,
          fields
        }).then(() => {
          this.reload()
        }).catch(e => {
          notification(AlertTypes.ERROR, 'Não foi possível salvar as colunas fixas.')
        })
      },
      closeDialog () {
        this.selectedItems = {}
        this.columns.forEach(item => {
          this.selectedItems[item.value] = false
        })

        this.show = false
      },
      reload () {
        this.$emit('reload')
        this.show = false
        return true
      }
    }
  }
</script>

<style scoped>
    p {
        font-weight: 700;
    }
    .checkbox-label {
      color: black;
    }
    .container-list-selecionados {
        width: '100%';
        display: flex;
        flex-direction: 'row';
        gap: 12px;
        flex-wrap: wrap;
        justify-content: 'center';
        margin-top: 12px;
        align-items: center;
        @media(min-width: 1024px) {
            justify-content: 'flex-start';
        }
    }
    .container-card-selecionado {
        display: flex;
        padding: 10px 12px;
        border-radius: 5px;
        background-color: var(--primary);
        justify-content: center;
        align-items: baseline;
        font-weight: 700;
        color: white;
    }
    .container-columns {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(20%, 1fr));
        gap: 10px;
    }
    .column {
        display: flex;
        justify-items: flex-start;
        font-weight: 700;
    }
</style>
